document.addEventListener('DOMContentLoaded', function() {
    const calculators = document.querySelectorAll('.bill-calculator');
    
    calculators.forEach(calculator => {
        const slider = calculator.querySelector('.input-slider');
        const kwhInput = calculator.querySelector('.input-kwh');
        const dollarInput = calculator.querySelector('.input-dollar');
        
        const price = parseFloat(calculator.dataset.price) || 0.10873;
        const minValue = parseInt(calculator.dataset.minValue) || 1;
        const maxValue = parseInt(calculator.dataset.maxValue) || 4000;

        // Get CSS custom properties for colors
        const sliderTrackColor = getComputedStyle(calculator).getPropertyValue('--slider-background-color').trim() || '#EBEBEB';
        const sliderThumbColor = getComputedStyle(calculator).getPropertyValue('--slider-color').trim() || '#e6e6e6';
       
        // Function to update slider gradient background
        function updateSliderGradient(value) {
            const percentage = ((value - minValue) / (maxValue - minValue)) * 100;
            
            // Set gradient: filled color up to thumb, track color after
            slider.style.background = `linear-gradient(to right, ${sliderThumbColor} 0%, ${sliderThumbColor} ${percentage}%, ${sliderTrackColor} ${percentage}%, ${sliderTrackColor} 100%)`;
        }
        
        // Initialize rangeslider if available
        if (typeof jQuery !== 'undefined' && jQuery.fn.rangeslider) {
            jQuery(slider).rangeslider({
                polyfill: false,
                onSlide: function(position, value) {
                    updateValues(value, 'slider');
                }
            });
        } else {
            // Initialize gradient for native slider
            updateSliderGradient(parseInt(slider.value));
        }
        
        // Updated function with source parameter to prevent feedback loops
        function updateValues(kwh, source = 'slider') {
            kwh = Math.max(minValue, Math.min(maxValue, parseInt(kwh) || minValue));
            const cost = (kwh * price).toFixed(2);
            
            // Only update inputs that aren't the source
            if (source !== 'kwh') {
                kwhInput.value = kwh;
            }
            if (source !== 'dollar') {
                dollarInput.value = cost;
            }
            
            if (slider && source !== 'slider') {
                slider.value = kwh;
                // Update gradient background
                updateSliderGradient(kwh);
                // Update rangeslider if it exists
                if (typeof jQuery !== 'undefined' && jQuery.fn.rangeslider) {
                    jQuery(slider).val(kwh).change();
                }
            } else if (source === 'slider') {
                updateSliderGradient(kwh);
            }
        }
        
        // Slider change
        if (slider) {
            slider.addEventListener('input', function() {
                updateValues(this.value, 'slider');
            });
        }
        
        // kWh input change - use blur instead of input for better UX
        kwhInput.addEventListener('input', function() {
            // Allow typing, only validate/update on blur
            this.value = this.value.replace(/[^0-9]/g, '');
        });
        
        kwhInput.addEventListener('blur', function() {
            let value = parseInt(this.value) || minValue;
            value = Math.max(minValue, Math.min(maxValue, value));
            updateValues(value, 'kwh');
        });
        
        // Dollar input change - use blur instead of input for better UX
        dollarInput.addEventListener('input', function() {
            // Allow typing, only validate/update on blur
            this.value = this.value.replace(/[^0-9.]/g, '');
        });
        
        dollarInput.addEventListener('blur', function() {
            let value = parseFloat(this.value) || (minValue * price);
            const kwh = Math.round(value / price);
            updateValues(kwh, 'dollar');
        });
        
        // Optional: Update on Enter key
        kwhInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                this.blur();
            }
        });
        
        dollarInput.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
                this.blur();
            }
        });
        
        // Prevent non-numeric input
        [kwhInput, dollarInput].forEach(input => {
            input.addEventListener('keypress', function(e) {
                // Allow digits, decimal point, backspace, delete, enter
                const allowedKeys = /[\d.]/;
                const isControlKey = ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight'].includes(e.key);
                
                if (!allowedKeys.test(e.key) && !isControlKey) {
                    e.preventDefault();
                }
                
                // Prevent multiple decimal points in dollar input
                if (e.key === '.' && this.value.includes('.')) {
                    e.preventDefault();
                }
            });
        });
    });
});